<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="400px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-text style="text-align: center" class="pt-3 pb-2"
        ><h3>{{ showText }}</h3></v-card-text
      >
      <v-card-actions class="modalActions">
        <v-row style="text-align: center" no-gutters>
          <v-col
            ><el-button
              title="Atšaukti"
              class="mb-1"
              :loading="loading"
              @click.native.stop="closeModal()"
              color="secondary"
          /></v-col>
          <v-col
            ><el-button
              title="Taip, vykdyti sunaikinimą"
              :loading="loading"
              @click.native="destroyData()"
              color="danger"
          /></v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalDestroyData',
  props: {
    item: Object,
    value: Boolean,
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      loading: false,
    }
  },
  computed: {
    showText() {
      return this.$t(
        'Sugeneruotame akte esantys objektai bus sunaikinti negrįžtamai. Ar norite tęsti'
      )
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  created() {
    this.modalloading = false
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    cancel() {
      this.closeModal()
    },
    destroyData() {
      this.loading = true
      this.$axios
        .post(`destruction-acts/${this.item.id}/approve`, this.item)
        .then(() => {
          this.$emit('listUpdate')
          this.closeModal()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
